var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGreenCard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 24.0025H27V12.0976H26.9867L27 5.99756H3V24.0025ZM25.4557 22.3173H4.55095V12.6018L25.4557 12.5874V22.3173ZM4.55095 10.9165V7.68282H25.4424V10.9021L4.55095 10.9165ZM6.00083 18.0009H12.0025V19.5013H6.00083V18.0009Z",
    fill: "#00EC25"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGreenCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/GreenCard.c14fb995d13892a72ade45216cb65a34.svg";